import { render, staticRenderFns } from "./preview-video.vue?vue&type=template&id=25c6aeaa&scoped=true&"
import script from "./preview-video.vue?vue&type=script&lang=ts&"
export * from "./preview-video.vue?vue&type=script&lang=ts&"
import style0 from "./preview-video.vue?vue&type=style&index=0&id=25c6aeaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c6aeaa",
  null
  
)

export default component.exports